export default "__VITE_ASSET__C2lNx2MS__"